// extracted by mini-css-extract-plugin
export var externalLink = "_6t-0";
export var internalLinkLabel = "_6t-1";